<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col titre">
      <h2>Message utilisateur</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="ajouter"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="messages"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          breakpoint="700px"
          responsiveLayout="scroll"
          :scrollableY="true"
          scrollHeight="500px"
          dataKey="cle"
          :paginator="true"
          :rows="10"
          sort-field="cle"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} messages"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="id"
            header="Clé"
            :sortable="true"
        ></Column>
        <Column
            field="message"
            header="Valeur"
            :sortable="true"
        ></Column>
        <Column
            field="niveauDescription"
            header="Niveau"
            :sortable="true"
        ></Column>
        <Column
            field="dateDebut"
            header="Date début"
            :sortable="true"
        >
          <template #body="slotProps">
            {{
              $commun.formatDateHeure(
                  slotProps.data.dateDebut
              )
            }}
          </template>
        </Column>
        <Column
            field="dateFin"
            header="Date fin"
            :sortable="true"
        >
          <template #body="slotProps">
            {{
              $commun.formatDateHeure(
                  slotProps.data.dateFin
              )
            }}
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="modifier(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue';

export default {
  emits: ['removeMessageFromList'],
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Message Utilisateur");    
    this.$store.dispatch('pilotage/rechercherMessageUtilisateurAction')
    .then((res) => {
      this.messages = res.data;
    });
  },
  components: {
    DialogConfirmation
  },
  data() {
    return {
      messages: [],
      messageToDelete: null
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    modifier(data){
      this.$store.commit('pilotage/MESSAGE_TO_UPDATE', data);
      this.$router.push({name: 'modifierMessageUtilisateur'});
    },
    ajouter(){
      this.$store.commit('pilotage/MESSAGE_TO_UPDATE', null);
      this.$router.push({name: 'ajouterMessageUtilisateur'});
    },
    confirmerSuppression(data) {
      this.messageToDelete = data.id
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer le message?",
        accept: this.supprimer,
        reject: () => {},
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerMessageAction', {id: this.messageToDelete}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Suppression Message',
          detail:"La suppression a été effectuée",
          life: 6000
        });
        this.messages = this.messages.filter(current => (current.id != this.messageToDelete))
      });
    },
  },
}
</script>
